import { render, staticRenderFns } from "./near.vue?vue&type=template&id=6835c55d&"
import script from "./near.vue?vue&type=script&lang=js&"
export * from "./near.vue?vue&type=script&lang=js&"
import style0 from "./near.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports